import React, { Component, Fragment } from 'react';
import { AddToMyFlow, HashMapItem, RemoveFromMyFlow } from 'types/MyFlow';
import { IArtist } from 'types/IArtist';
import {
  Day,
  getVenueNameByID,
  getVenues,
  sortEventItemsByDay,
  sortEventsByTimeASC, translateVenueName,
} from '@flow/utils/helperUtils';
import * as myFlowActions from '@flow/store/myflow/actions';
import { MyFlowState } from '@flow/store/myflow/reducer';
import { withRouteData } from "react-static";
import { connect } from 'react-redux';
import moment from 'moment';
import Moment from 'react-moment';
import {
  DayTitle,
  DayTitleWrapper,
  DayWrapper,
  EventsWrapper,
  ScheduleWrapper,
  VenueTitle
} from '@flow/scenes/schedule/ui/index';
import { GridRowAfterStripe } from '@flow/components/grid/grid';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { ListActionItem } from '@flow/scenes/schedule/ui/ListActionItem';

export const renderDayTitle = (locale: string, date: string, format: string, doNotShowAdditionalText:boolean = false) => {
  if (moment(date).isValid()) {
    return (
      <Moment locale={locale} format={format} date={date}/>
    )
  } else if(!doNotShowAdditionalText) {
    return (
      <span>Tba</span>
    )
  }
  return null;
};

type Props = {
  appLanguage: IAppLanguage;
  myFlow: MyFlowState;
  addToMyFlow: (params: AddToMyFlow) => any;
  removeFromMyFlow: (params: RemoveFromMyFlow) => any;
}

type State = {
  selectedEvents: IArtist[];
}

class ScheduleConnected extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedEvents: []
    }
  }

  // ToDo: Similar code has been used for artists listing so investigate if we can make abstract component of functional structure.
  render() {
    const {
      myFlow: {
        eventIdHashMap,
      },
      appLanguage
    } = this.props;

    let eventsByDay: Day[] = sortEventItemsByDay(eventIdHashMap);

    return (
      <ScheduleWrapper>
        {eventsByDay.map((day: Day, index: number) => (
          <Fragment key={index}>
            <DayTitleWrapper>
              <DayTitle>{renderDayTitle(appLanguage.code, day.date, 'ddd D.M.')}</DayTitle>
            </DayTitleWrapper>
            {this._renderEventDaySchedule(day, index)}
          </Fragment>
        ))}
      </ScheduleWrapper>
    )
  }

  private _renderEventDaySchedule = (day: Day, index: number) => {

    let eventsByVenue: any[] = [];

    if (day) {
      const { events } = day;
      if (events) {
        let venueIDs: number[] = getVenues() || [];
        for (let i: number = 0; i < venueIDs.length; i++) {
          let venueID: number = venueIDs[i];
          let venueArtists: HashMapItem[] = events.filter((artist: HashMapItem) => {
            return artist.event.venue_id === venueID;
          });
          if (venueArtists.length > 0) {
            eventsByVenue.push(
              {
                name: translateVenueName(this.props.appLanguage.code, getVenueNameByID(venueID)),
                artists: venueArtists.sort(sortEventsByTimeASC)
              }
            );
          }
        }
      }
    }

    return (
      <Fragment>
        <DayWrapper key={index}>
          {eventsByVenue.map((venue: any, index: number) =>
            <EventsWrapper key={index}>
              <VenueTitle>{venue.name}</VenueTitle>
              {venue.artists && venue.artists.map((artist: HashMapItem, index: number) =>
                <ListActionItem item={artist} key={index} />
              )}
            </EventsWrapper>
          )}
        </DayWrapper>

        <GridRowAfterStripe className={'force-show'}>
          <FlowStripe animate={true} color={'#000000'} />
        </GridRowAfterStripe>
      </Fragment>
    )
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    addToMyFlow: (params: AddToMyFlow) => dispatch(myFlowActions.addToMyFlow(params)),
    removeFromMyFlow: (params: RemoveFromMyFlow) => dispatch(myFlowActions.removeFromMyFlow(params)),
  };
};

export const Schedule = withRouteData(connect(
  (state: any) => ({
    myFlow: state.myFlowReducer
  }), mapDispatchToProps
)(ScheduleConnected));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/schedule/ui/Schedule.tsx